import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {
	MV_AUTH_INTERCEPTOR_CONFIG,
	mvAuthInterceptor,
	SERIES_NAME,
	SERVER_ENDPOINT,
} from '@vbrick/vb-lxp-lib';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ENABLE_TWITCH_STREAM_SELECTOR } from '@vbrick/vb-lxp-lib';

import { environment } from 'projects/vb-lxp-sro/src/environments/environment';

export const appConfig: ApplicationConfig = {
	providers: [
		provideBrowserGlobalErrorListeners(),
		provideRouter(routes),
		{
			provide: SERVER_ENDPOINT,
			useValue: environment.serverEndpoint,
		},
		{
			provide: ENABLE_TWITCH_STREAM_SELECTOR,
			useValue: false,
		},
		{
			provide: MV_AUTH_INTERCEPTOR_CONFIG,
			useValue: { requiresAuth: false },
		},
		{
			provide: SERIES_NAME,
			useValue: 'SRO',
		},
		provideHttpClient(withInterceptors([mvAuthInterceptor])),
		provideAnimations(),
	],
};
